import { CssPropertyType } from '@wix/ambassador-devcenter-v1-component-type-data/types';

const COMBINED_PADDING_CSS_PROPERTY_TYPES = [CssPropertyType.padding];

export const PADDING_CSS_PROPERTY_TYPES = [
  ...COMBINED_PADDING_CSS_PROPERTY_TYPES,
  CssPropertyType.paddingTop,
  CssPropertyType.paddingRight,
  CssPropertyType.paddingBottom,
  CssPropertyType.paddingLeft,
  CssPropertyType.paddingInlineStart,
  CssPropertyType.paddingInlineEnd,
];

const COMBINED_GAP_CSS_PROPERTY_TYPES = [CssPropertyType.gap];

export const GAP_CSS_PROPERTY_TYPES = [
  ...COMBINED_GAP_CSS_PROPERTY_TYPES,
  CssPropertyType.rowGap,
  CssPropertyType.columnGap,
];
